export const adminId = "6BD5jUgHquViXm9YRvRHZhI0NBe2";
